export default __webpack_public_path__ + "static/media/sun.15b8db63.jpg";